import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import globalText from "../../../../utils/globalText";
import IconTearDropButton from "../../../_utils/CommonButtons/IconTearDropButton";
import Chips from "../../CommonButtons/Chips";
import PrimaryWithIconButton from "../../CommonButtons/PrimaryWithIconButton";

const AssignLabels = ({
  setLabelpopup,
  labels,
  subText1,
  subText2,
  isOptional,
  previewMode = false,
  type,
}) => {
  const services = useSelector((state) => state.refreshToken.services);
  const hasALabel = services?.includes("ALabel");
  const hasRLabel = services?.includes("RLabel");
  const navigate = useNavigate();
  const isServiceMissing = !(hasALabel && hasRLabel);
  const handleLabelPopup = () => {
    if (isServiceMissing) {
      navigate("/feature_not_assigned", {
        state: { unavailableService: "ALabel,RLabel" },
      });
    } else {
      setLabelpopup(true);
    }
  };

  if (previewMode) {
    return (
      <div className="flex flex-col bg-primary-card p-padding-md rounded-border-radius-md gap-gap-md">
        <div className="text-text-primary text-font-md">
          <span className="font-semibold">{globalText?.LABELS}</span>
          {isOptional && <span className="font-normal"> (Optional)</span>}
        </div>

        <div className="w-width-full flex flex-col gap-gap-xs">
          <p className="text-text-primary text-font-md">
            {labels?.length === GlobalConfiguration?.lengthCheckZero ? (
              <div className="mb-margin-xs">Not assigned</div>
            ) : (
              labels.map((item, index) => (
                <span
                  key={index}
                  className="break-all"
                >
                  {item}
                  {index <
                    labels.length - GlobalConfiguration?.lengthCheckOne && ", "}
                </span>
              ))
            )}
          </p>
          <p className="text-text-secondary text-font-xs font-normal">
            {globalText?.LABELS}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col relative">
      <div className="p-padding-md h-height-full bg-primary-card flex flex-col rounded-border-radius-md">
        <div className="w-width-full flex flex-col gap-gap-md">
          <div className="flex justify-between items-start">
            <div className="flex flex-col gap-gap-xs">
              <div className="text-text-primary text-font-md">
                <span className="font-semibold">Labels</span>
                {isOptional && <span className="font-normal"> (Optional)</span>}
              </div>
              <div className="text-text-secondary text-font-xs">{subText1}</div>
            </div>

            {labels?.length > GlobalConfiguration.lengthCheckZero && (
              <div className="top-top-base right-right-base absolute">
                <IconTearDropButton
                  handleFunction={() => handleLabelPopup()}
                  isDisabled={false}
                  isLoading={false}
                  enabledBgColor={"var(--primary-nav-act)"}
                  icon={ICONS?.EDIT}
                  title="Edit"
                  hoverOption="white"
                />
              </div>
            )}
          </div>
          {labels?.length > GlobalConfiguration.lengthCheckZero ? (
            <div>
              <p className="text-text-secondary text-font-xs">{subText2}</p>
              <div className="flex flex-wrap gap-gap-sm mt-margin-sm">
                {labels.map((item, index) => (
                  <Chips
                    txtChip={item}
                    enabledTextColor="var(--text-primary)"
                    enabledBgColor="var(--primary-nav)"
                    isTickerRequired={false}
                  />
                ))}
              </div>
            </div>
          ) : (
            <PrimaryWithIconButton
              btnText="Assign labels"
              enabledBgColor="var(--primary-nav-act)"
              isDisabled={false}
              handleFunction={() => {
                setLabelpopup(true);
              }}
              iconToBeAlign="left"
              enabledTextColor={"var(--text-primary)"}
              icon={ICONS?.LABEL}
              fullWidthRequired={true}
              hoverOption="white"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AssignLabels;
